import { Country } from '../types/country';

export const ALLOWANCE_CAF =
  'http://www.caf.fr/allocataires/droits-et-prestations/s-informer-sur-les-aides/petite-enfance/le-complement-de-libre-choix-du-mode-de-garde';

export const SPONSORSHIP = 'https://www.wecasa.fr/customer-area/sponsorship';

export const PRO_CHILDCARE_INSCRIPTION_LINK = 'https://www.wecasa.fr/pro/inscription-nounou';

export const BOOKING_INFOS_SURVEY_CLEANING_RECURRING_LINK = 'https://survey.zohopublic.com/zs/zCBTJ4';
export const BOOKING_INFOS_SURVEY_CLEANING_SPOT_LINK = 'https://survey.zohopublic.com/zs/EWBTlg';

export const EVENT_TRACKING_CONSENT_DETAILS_LINK = 'https://www.wecasa.fr/page/cookie-policy';

/* TODO: For now, This code should be updated when we handle all locales. */
export const WECASA_PRIVACY_POLICIES_LINKS: Record<Extract<Country, 'FR' | 'GB'>, string> = {
  FR: 'https://www.wecasa.fr/page/politique-cookies',
  GB: 'https://www.wecasa.co.uk/page/cookie-policy ',
  // DE: 'https://www.wecasa.de/page/cookie-richtlinie',
  // AT: 'https://www.wecasa.at/page/cookie-richtlinie',
  // 'CH-DE': 'https://www.wecasa.ch/de-ch/page/cookie-richtlinie',
  // 'CH-FR': 'https://www.wecasa.ch/fr-ch/page/politique-cookies',
};

export const PARTNERS_PRIVACY_POLICY_LINKS = {
  Amplitude: 'https://amplitude.com/privacy',
  Firebase: 'https://firebase.google.com/support/privacy',
  AppsFlyer: 'https://www.appsflyer.com/legal/privacy-policy/',
  Meta: 'https://www.facebook.com/privacy/policy/?entry_point=data_policy_redirect&entry=0',
  TikTok: 'https://www.tiktok.com/legal/page/eea/privacy-policy/en',
  Intercom: 'https://www.intercom.com/legal/privacy',
};
